export default {
  data: {
    // ldc to pass, set by server
    modelLdc: null,
    // the account number value
    modelAccountNumber: null,
    // the phone number value
    modelPhone: null,
    // date of birth
    modelDateOfBirth: [],
    // ssn
    modelLast4Ssn: [],
    // Tax ID
    modelTaxId: [],
    // PIN
    modelPin: [],
    // whether to show the verify fields
    showVerifyFields: false,
    // whether to show alternative lookup fields
    showAlternateLookup: false,
    disabledSearchByPhone: false,
  },
  mounted() {
    // Find the LDC for which the account should be created.
    // This will be added to the DOM via back-end.
    if (this.$el.dataset.ldc) {
      this.modelLdc = this.$el.dataset.ldc;
      // now we're ready to do LDC specific things
      // like mask in our account lookup component
      this.isReady = true;
    }
  },
  /**
   * Computed
   */
  computed: {
    unmaskedAccountNumber() {
      return this.modelAccountNumber ? this.modelAccountNumber.replace(/-/g, "") : '';
    },
    unmaskedPhoneNumber() {
      return this.modelPhone ? this.modelPhone.replace(/\D/g, "") : '';
    },
  },
  /**
   * Methods
   */
  methods: {
    /**
     * Show the alternative lookup fields
     */
    clickShowAlternateLookup() {
      this.clearVerifyFields(this);
      this.showVerifyFields = false;
      this.showAlternateLookup = true;
      this.modelAccountNumber = null;
      this.enableConfirmAccountButton = false;
      Vue.nextTick(() => {
        document.querySelector('#phone-input').focus();
      });
    },
    /**
     * Helper function to clear the fields and hide the verify fields
     * @param {object} model The Vue instance
     */
    clearVerifyFields() {
      /* eslint-disable no-param-reassign */
      this.modelDateOfBirth = [];
      this.modelLast4Ssn = [];
      this.modelTaxId = [];
      this.showVerifyFields = false;
      /* eslint-enable */
    },
    /**
     * Click on the "I remember my account number" link
     */
    clickHideAlternateLookup() {
      this.clearVerifyFields(this);
      this.showAlternateLookup = false;
      this.modelPhone = null;
      this.disabledSearchByPhone = true;
      this.showVerifyFields = false;
      Vue.nextTick(() => {
        document.querySelector('#account-number-input').focus();
      });
    },

    listenForLoading(data) {
      // if the child calls loading, listen to it
      this.loading = data;
    },
  },
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/vue/mixins/accountLookup.js